export enum EodDocumentType {
  Inventory = '1',
  Trash     = '2',
  Transfert = '3',
}

